import React, { Component } from 'react';
import IconForm from './IconForm';
class TextArea extends Component {
	render() {
		return (
			<div className="control">
				<textarea className={this.props.styleName || null}  placeholder={this.props.placeholder || null} id={this.props.htmlFor} name={this.props.name || null} required={this.props.required || null} />
			</div>
		);
	}
}

export default TextArea;
